export default __webpack_public_path__ + "static/article-how-to-get-out-of-debt-abf170d73f1bf7b947ea7bc65a054635.jpg";